var map = {
	"./background.png": 18,
	"./card_back.png": 6,
	"./cat.png": 19,
	"./elephant.png": 20,
	"./fox.png": 21,
	"./george.png": 22,
	"./mama.png": 23,
	"./papa.png": 24,
	"./peppa.png": 25,
	"./peppa_george.png": 26,
	"./rabbit.png": 27,
	"./zebra.png": 28
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;